import {useViewer} from '../../state/viewer/hooks';
import {
  CUSTOM_DEFAULT_ORG_FLAGS,
  CUSTOM_DEFAULT_USER_FLAGS,
} from './customDefaultFlags';
import {useCustomDefault} from './useCustomDefault';

/**
 * Check if a user is member of an organization that is signed up to use the max runs custom default or if a user is a specifically allowed user
 * NOTE: this logic return TRUE if a user is either an allowed user OR in an allowed org. It does not allow specific deflagging of users within an allowed org
 * @returns boolean
 */
export const useUserCanConfigureMaxRuns = (
  viewerHook: typeof useViewer = useViewer,
  orgFlags: typeof CUSTOM_DEFAULT_ORG_FLAGS = CUSTOM_DEFAULT_ORG_FLAGS,
  userFlags: typeof CUSTOM_DEFAULT_USER_FLAGS = CUSTOM_DEFAULT_USER_FLAGS
) => {
  const viewer = viewerHook();

  const viewerOrgs: string[] =
    viewer?.organizations?.map(org => org.name) || [];
  const allowedOrgs = Object.entries(orgFlags['custom-max-runs'])
    .filter(([_, val]) => !!val)
    .map(([key]) => key);

  const allowedUsers = Object.entries(userFlags['custom-max-runs'])
    .filter(([_, val]) => !!val)
    .map(([key]) => key);

  const allowed = new Set(allowedOrgs);
  return (
    viewerOrgs.some(org => allowed.has(org)) ||
    allowedUsers.includes(viewer?.username ?? '')
  );
};

/**
 * Get the max runs that are defaulted in the panels
 * If a user can use the custom default, return that value
 */

export const DEFAULT_NUM_RUNS = 10;
export const DEFAULT_MAX_GROUP_RUNS = 100;

export const useDefaultMaxRuns = () => {
  const userCanConfigureMaxRuns = useUserCanConfigureMaxRuns();
  const {userSelectedValue} = useCustomDefault('custom-max-runs');

  if (userCanConfigureMaxRuns && userSelectedValue) {
    return Number(userSelectedValue);
  }

  return DEFAULT_NUM_RUNS;
};

// these are the same right now
export const useDefaultMaxGroupRuns = () => {
  const userCanConfigureMaxRuns = useUserCanConfigureMaxRuns();
  const {userSelectedValue} = useCustomDefault('custom-max-runs');

  if (userCanConfigureMaxRuns && userSelectedValue) {
    return Number(userSelectedValue);
  }
  return DEFAULT_MAX_GROUP_RUNS;
};
